module.exports = __webpack_public_path__ + "static/media/timeline-atual.ca936d9a.svg";